import { ADD_PARTICIPANT_SUCCESS } from "../actions/currentConversation/addParticipant"
import {  FETCH_CURRENT_CONVERSATION_MESSAGES_BEGIN, 
          FETCH_CURRENT_CONVERSATION_MESSAGES_SUCCESS, 
          FETCH_CURRENT_CONVERSATION_MESSAGES_FAILED  } from "../actions/currentConversation/fetchCurrentConversationMessages"
import {  FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_BEGIN, 
          FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_SUCCESS, 
          FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_FAILED,
          REACHED_END_OF_CONVERSATION_MESSAGES } from "../actions/currentConversation/fetchMoreConversationData"
import { REMOVE_PARTICIPANT_SUCCESS } from "../actions/currentConversation/removeParticipant"
import { SET_CURRENT_CONVERSATION } from "../actions/currentConversation/setCurrentConversation"

const initialState = {
  messages: [],
  loading: true,
  loadingMoreMessages: false,
  canLoadMoreMessages: true,
  page: 1, 
  scrollPosition: 0,
}

export function currentConversation(state=initialState, { type, payload }) {
  switch(type){
    case ADD_PARTICIPANT_SUCCESS:
    case REMOVE_PARTICIPANT_SUCCESS: 
    case FETCH_CURRENT_CONVERSATION_MESSAGES_BEGIN:
      return { ...state, ...payload }
    case FETCH_CURRENT_CONVERSATION_MESSAGES_SUCCESS:
      return { ...state, messages: [...payload.reverse()], 
          loading: false, loadingMoreMessages: false, 
          canLoadMoreMessages: true, page: 1, scrollPosition: 0}
    case FETCH_CURRENT_CONVERSATION_MESSAGES_FAILED: 
      return { loading: false }
    case SET_CURRENT_CONVERSATION:
      return { ...payload, messages: [] }
    case FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_BEGIN:
      return { ...state, ...payload, page: state.page + 1 }
    case FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_SUCCESS:
      return { ...state, messages: [...[...payload.reverse()], ...state.messages], loadingMoreMessages: false }
    case FETCH_CURRENT_CONVERSATION_MORE_MESSAGES_FAILED:
      return { ...state, loadingMoreMessages: false }
    case REACHED_END_OF_CONVERSATION_MESSAGES:
      return { ...state, canLoadMoreMessages: false, loadingMoreMessages: false}
    default:
      return state
  }
}